export const TRANSLATIONS = {
  ro: {
    largeFont: "Font mare",
    loading: "Se încarcă datele...",
    pinnedEvents: "Evenimente fixate",
    dateArchive: "Arhivă după dată",
    emptyArchive: "Nu există evenimente",
    months: {
      "01": "Ianuarie", "02": "Februarie", "03": "Martie", "04": "Aprilie",
      "05": "Mai", "06": "Iunie", "07": "Iulie", "08": "August",
      "09": "Septembrie", "10": "Octombrie", "11": "Noiembrie", "12": "Decembrie",
      "00": "Fără dată"
    },
    editDish: "Editează felul",
    addDish: "Adaugă fel",
    uploadPhoto: "Încarcă foto",
    category: "Categorie",
    catPlaceholder: "Selectați sau introduceți una nouă...",
    dishName: "Denumire",
    weight: "Gramaj",
    price: "Preț",
    saveLocal: "Salvează (doar în acest banchet)",
    saveAsNew: "Salvează ca nou",
    updateInMenu: "Actualizează în Meniu",
    photoNotAvailable: "Funcția de adăugare a fotografiilor nu este disponibilă în această versiune",
    save: "Salvează",
    cancel: "Anulează",
    photoNotAvailable: "Funcția de adăugare a fotografiilor nu este disponibilă în această versiune",
    techDanceFloor:"Ring de dans",
    pcs: "buc.",
    pricePerPerson: "Preț per persoană", 
    toPay: "Rămas de achitat",
    appTitle: "Manager Banchete",
    loginBtn: "Autentificare",
    password: "Parola",
    back: "Înapoi",
    menuBtn: "Meniu", 
    newBanquet: "Banchet Nou",
    myBanquets: "Banchetele Mele",
    banquets: "Banchete",
    search: "Căutare...",
    date: "Data",
    guests: "Oaspeți",
    hall: "Sala",
    total: "Total",
    actions: "Acțiuni",
    edit: "Editare",
    delete: "Ștergere",
    save: "Salvare",
    printClient: "Print Client",
    printKitchen: "Print Bucătărie/Sala",
    printInvoice: "Print Cont", 
    clientName: "Nume Client",
    startTime: "Ora început",
    eventType: "Tip eveniment",
    prepayment: "Avans",
    servicePercent: "Deservire (%)",
    totalMenu: "Total Meniu",
    service: "Deservire",
    colDish: "Denumire Produs",
    colWeight: "Gramaj",
    colQty: "Cant",
    colPrice: "Preț",
    colSum: "Suma",
    saved: "Salvat!",
    confirmDelete: "Sigur doriți să ștergeți?",
    typeBanquet: "Meniu Banchet",
    typeBuffet: "Meniu Fourchette",
    adminPanel: "Panou Administrator",
    manageDishes: "Gestionare Meniu",
    manageCategories: "Categorii",
    manageHalls: "Săli",
    dishName: "Denumire",
    price: "Preț",
    weight: "Gramaj",
    category: "Categorie",
    addDish: "Adaugă Produs",
    addCategory: "Adaugă Categorie",
    addHall: "Adaugă Sală",
    uploadPhoto: "Încarcă Foto",
    saveAsNew: "Salvează ca Nou",
    editDish: "Editare Produs",
    addCustom: "+ Adaugă personalizat",
    locked: "Ecran blocat",
    catNotePlaceholder: "Notă pentru categorie (ex: Se servește la ora 14:00)",
    add: "Adaugă",
    catNamePlaceholder: "Nume categorie (ex: Supe)",
    dishNamePlaceholder: "Denumire produs",
    weightPlaceholder: "Gramaj (g)",
    pricePlaceholder: "Preț (MDL)",
    selectCategory: "-- Selectează categoria --",
    companyData: "Logo Companie",
    searchMenuPlaceholder: "Caută în meniu...",
    noDishesInCat: "Nu sunt produse în această categorie",
    exportData: "Export Date",
    importData: "Import Date",
    restoreConfirm: "Aceasta va înlocui toate datele curente. Continuați?",
    dataRestored: "Datele au fost restaurate!",
    fileError: "Eroare fișier.",
    hallInUse: "Sala este utilizată în banchete!",
    deleteConfirm: "Ștergeți",
    copy: "copie",
    searchPlaceholder: "Client, eveniment sau AAAA-LL-ZZ",
    techTitle: "Echipament tehnic",
    techLed: "Ecrane LED (buc)",
    techMic: "Microfoane (buc)",
    techLight: "Lumini",
    techSound: "Sunet",
    techSum: "Sumă / Cifre",
    allHalls: "Toate sălile",
    nothingFound: "Nimic găsit"
  },
  ru: {
    largeFont: "Крупный шрифт",
    loading: "Загрузка данных...",
    pinnedEvents: "Закрепленные мероприятия",
    dateArchive: "Архив по датам",
    emptyArchive: "Нет событий",
    months: {
      "01": "Январь", "02": "Февраль", "03": "Март", "04": "Апрель",
      "05": "Май", "06": "Июнь", "07": "Июль", "08": "Август",
      "09": "Сентябрь", "10": "Октябрь", "11": "Ноябрь", "12": "Декабрь",
      "00": "Без даты"
    },
    editDish: "Редактировать блюдо",
    addDish: "Добавить блюдо",
    uploadPhoto: "Загрузить фото",
    category: "Категория",
    catPlaceholder: "Выберите или введите новую...",
    dishName: "Название",
    weight: "Вес/Выход",
    price: "Цена",
    saveLocal: "Сохранить (только в этом банкете)",
    saveAsNew: "Сохранить как новое",
    updateInMenu: "Обновить в Меню",
    photoNotAvailable: "Функция добавления фото недоступна в данной версии",
    save: "Сохранить",
    cancel: "Отмена",
    photoNotAvailable: "Функция добавления фото недоступна в данной версии",
    techDanceFloor:"Танцпол",
    pcs: "шт.",
    pricePerPerson: "Цена за персону",   
    toPay: "К оплате",
    appTitle: "Банкет Менеджер",
    loginBtn: "Войти",
    password: "Пароль",
    back: "Назад",
    menuBtn: "Меню", 
    newBanquet: "Новый Банкет",
    myBanquets: "Мои Банкеты",
    banquets: "Банкеты",
    search: "Поиск...",
    date: "Дата",
    guests: "Гости",
    hall: "Зал",
    total: "Итого",
    actions: "Действия",
    edit: "Ред.",
    delete: "Удалить",
    save: "Сохранить",
    printClient: "Печать (Клиент)",
    printKitchen: "Печать (Кухня/Зал)",
    printInvoice: "Счет", 
    clientName: "Имя Клиента",
    startTime: "Начало",
    eventType: "Тип события",
    prepayment: "Аванс",
    servicePercent: "Обслуживание (%)",
    totalMenu: "Всего по меню",
    service: "Обслуживание",
    colDish: "Наименование",
    colWeight: "Выход",
    colQty: "Кол-во",
    colPrice: "Цена",
    colSum: "Сумма",
    saved: "Сохранено!",
    confirmDelete: "Вы уверены?",
    typeBanquet: "Банкетное меню",
    typeBuffet: "Фуршетное меню",
    adminPanel: "Админ панель",
    manageDishes: "Управление меню",
    manageCategories: "Категории",
    manageHalls: "Залы",
    dishName: "Название",
    price: "Цена",
    weight: "Вес/Выход",
    category: "Категория",
    addDish: "Добавить блюдо",
    addCategory: "Добавить категорию",
    addHall: "Добавить зал",
    uploadPhoto: "Загрузить фото",
    saveAsNew: "Сохранить как новое",
    editDish: "Редактировать блюдо",
    locked: "Экран заблокирован",
    catNotePlaceholder: "Примечание к подаче (напр: Подать в 14:00)",
    addCustom: "+ Добавить свое",
    add: "Добавить",
    catNamePlaceholder: "Название категории (напр. Супы)",
    dishNamePlaceholder: "Название блюда",
    weightPlaceholder: "Вес/Выход (гр)",
    pricePlaceholder: "Цена (MDL)",
    selectCategory: "-- Выберите категорию --",
    companyData: "Логотип компании",
    searchMenuPlaceholder: "Поиск по меню...",
    noDishesInCat: "В этой категории пока нет блюд",
    exportData: "Экспорт",
    importData: "Импорт",
    restoreConfirm: "Это заменит все текущие данные. Продолжить?",
    dataRestored: "Данные восстановлены!",
    fileError: "Ошибка файла.",
    hallInUse: "Зал используется в банкетах!",
    deleteConfirm: "Удалить",
    copy: "копия",
    searchPlaceholder: "Клиент, событие или ГГГГ-ММ-ДД",
    techTitle: "Техническое оборудование",
    techLed: "LED Экраны (кол-во)",
    techMic: "Микрофоны (кол-во)",
    techLight: "Свет",
    techSound: "Звук",
    techSum: "Сумма / Цифры",
    allHalls: "Все залы",
    nothingFound: "Ничего не найдено"
  },
  en: {
    largeFont: "Large font",
    loading: "Loading data...",
    pinnedEvents: "Pinned Events",
    dateArchive: "Archive by Date",
    emptyArchive: "No events",
    months: {
      "01": "January", "02": "February", "03": "March", "04": "April",
      "05": "May", "06": "June", "07": "July", "08": "August",
      "09": "September", "10": "October", "11": "November", "12": "December",
      "00": "No date"
    },
    editDish: "Edit Dish",
    addDish: "Add Dish",
    uploadPhoto: "Upload Photo",
    category: "Category",
    catPlaceholder: "Select or type new...",
    dishName: "Name",
    weight: "Weight",
    price: "Price",
    saveLocal: "Save (only in this banquet)",
    saveAsNew: "Save as New",
    updateInMenu: "Update in Menu",
    photoNotAvailable: "Photo upload function is not available in this version",
    save: "Save",
    cancel: "Cancel",
    photoNotAvailable: "Photo upload function is not available in this version",
    techDanceFloor:"Dance floor",
    pcs: "pcs",
    pricePerPerson: "Price per person",
    toPay: "To Pay",
    appTitle: "Banquet Manager",
    loginBtn: "Login",
    password: "Password",
    back: "Back",
    menuBtn: "Menu", 
    newBanquet: "New Banquet",
    myBanquets: "My Banquets",
    banquets: "Banquets",
    search: "Search...",
    date: "Date",
    guests: "Guests",
    hall: "Hall",
    total: "Total",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    printClient: "Print Client",
    printKitchen: "Print Kitchen/Hall",
    printInvoice: "Invoice", 
    clientName: "Client Name",
    startTime: "Start Time",
    eventType: "Event Type",
    prepayment: "Prepayment",
    servicePercent: "Service (%)",
    totalMenu: "Total Menu",
    service: "Service",
    colDish: "Dish Name",
    colWeight: "Weight",
    colQty: "Qty",
    colPrice: "Price",
    colSum: "Sum",
    saved: "Saved!",
    confirmDelete: "Are you sure you want to delete?",
    typeBanquet: "Banquet Menu",
    typeBuffet: "Buffet Menu",
    adminPanel: "Admin Panel",
    manageDishes: "Manage Menu",
    manageCategories: "Categories",
    manageHalls: "Halls",
    dishName: "Name",
    price: "Price",
    weight: "Weight",
    category: "Category",
    addDish: "Add Dish",
    addCategory: "Add Category",
    addHall: "Add Hall",
    uploadPhoto: "Upload Photo",
    saveAsNew: "Save as New",
    editDish: "Edit Dish",
    locked: "Screen Locked",
    catNotePlaceholder: "Category note (e.g. Serve at 14:00)",
    add: "Add",
    catNamePlaceholder: "Category Name (e.g. Soups)",
    dishNamePlaceholder: "Dish Name",
    weightPlaceholder: "Weight (g)",
    pricePlaceholder: "Price (MDL)",
    selectCategory: "-- Select Category --",
    addCustom: "Add custom...",
    companyData: "Company Logo",
    searchMenuPlaceholder: "Search menu...",
    noDishesInCat: "No dishes in this category",
    exportData: "Export Data",
    importData: "Import Data",
    restoreConfirm: "This will replace all current data. Continue?",
    dataRestored: "Data restored!",
    fileError: "File error.",
    hallInUse: "Hall is in use!",
    deleteConfirm: "Delete",
    copy: "copy",
    searchPlaceholder: "Client, event or YYYY-MM-DD",
    techTitle: "Technical Equipment",
    techLed: "LED Screens (qty)",
    techMic: "Microphones (qty)",
    techLight: "Light",
    techSound: "Sound",
    techSum: "Sum / Numbers",
    allHalls: "All Halls",
    nothingFound: "Nothing found"
  }
};

export const DEMO_ADMINS = [
  { id: 1, name: "Admin", password: "123" },
  { id: 2, name: "Manager", password: "456" },
];

export const EVENT_TYPES = ["Nunta", "Cumatria", "Zi de nastere", "Corporativ", "Fourchette", "Masa de pomenire"];

export const STATUSES = [
  { label: "activ", color: "#16a34a", bg: "#dcfce7" }, 
  { label: "draft", color: "#94a3b8", bg: "#f1f5f9" }, 
  { label: "completed", color: "#3b82f6", bg: "#dbeafe" },
  { label: "template", color: "#d97706", bg: "#fef3c7" }
];